import React from "react";
import { Async } from "react-select";
import { getStores } from "../../../backend/stores";

import Overlay from "../../../components/overlay";

export default function() {
  const { comments = [], storeSelect, loading } = this.state;
  return (
    <div>
      <label>Store Location</label>
      <Async
        value={storeSelect}
        onChange={this._selectStore}
        loadOptions={getStores}
      />
      <div>
        {loading && <Overlay />}
        {comments.length === 0 &&
          !loading && (
            <div className="placeholder">
              {navigator.onLine ? "No reports" : "Could not retreive reports"}
            </div>
          )}
        {comments.map((comment, index) =>
          this._renderStoreComment(comment, index)
        )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/stores/comment-list/view.js